import { useCallback, useMemo } from "react";
import { useCurrency } from "./use-currency";

export const useGmvFormatter = ({ compact = true }: { compact?: boolean } = {}) => {
  const currency = useCurrency();
  const formatter = useMemo(
    () =>
      new Intl.NumberFormat(undefined, {
        style: "currency",
        currency,
        currencyDisplay: "narrowSymbol",
        ...(compact
          ? { notation: "compact" as const, compactDisplay: "short" as const }
          : { maximumFractionDigits: 0 }),
      }),
    [currency, compact],
  );
  return useCallback((gmv: number | null | undefined) => (gmv == null ? "—" : formatter.format(gmv)), [formatter]);
};
